module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "opacity"
    }
  }, [(_vm.show) ? _c('div', {
    staticClass: "y-loading"
  }, [_c('div', {
    staticClass: "y-loading-content",
    style: ({
      'width': _vm.width + '%',
      'background': _vm.bg
    })
  }), _vm._v(" "), _c('y-svg', {
    staticClass: "ion-load-c",
    attrs: {
      "type": "loading",
      "color": _vm.bg
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.9.9.5@vue-loader/lib/template-compiler.js?id=data-v-c6380292!./~/.9.9.5@vue-loader/lib/selector.js?type=template&index=0!./components/components/loading/loading.vue
// module id = 498
// module chunks = 27